
import Vue from 'vue';

interface Props {
  formType: string;
}

interface Methods {
  auth: (type: string) => void;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  props: {
    formType: {
      type: String,
      required: true,
    },
  },
  methods: {
    async auth(type) {
      const translations = {
        no_email: this.$t('portal_login.social.no_email'),
        email_exists: this.$t('portal_login.social.email_exists'),
        login_instead: this.$t('portal_login.social.login_instead'),
        singup_instead: this.$t('portal_login.social.singup_instead'),
      };

      try {
        await this.$store.dispatch(`customer/socialLogin`, { type, translations });
      } catch (error) {
        this.$emit('error', error?.message);
      }
    },
  },
});
